import React from 'react';
import { Badge, Popover, OverlayTrigger } from 'react-bootstrap';

const TypeBadge = ({ type }) => {
    const bgColor = type === 'I' ? 'info' : 'warning';
    const popover = (
        <Popover id="badge-popover">
            <Popover.Body>
                {type === 'I' ? 'Insumo' : 'Serviço'}
            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="top"
            overlay={popover}
        >
            <Badge bg={bgColor}>
                {type}
            </Badge>
        </OverlayTrigger>
    );
};

export default TypeBadge;